import {
  getNow,
  getActiveResources,
  isBefore,
  getPreviousMonth,
  printDate,
} from '@kathondvla/sri-client/date-utils';
import { loop, Cmd } from 'redux-loop';
import SriClientError from '@kathondvla/sri-client/sri-client-error';
import { fetchUser } from 'ReduxLoop/user/userActions';
import { getOrganisationalUnit } from 'ReduxLoop/user/userCommands';
import {
  getGoverningInstitutionOfOu,
  getVosEquivalent,
  getMainstructuresForOu,
} from 'ReduxLoop/ouManager/schoolManagerCommands';
import { getDefaultTab, getCurrentUserRole } from 'ReduxLoop/appConfig';
import { storeResource } from 'ReduxLoop/utils';
import {
  addErrorNotification,
  addSuccessNotification,
} from 'ReduxLoop/notifications/notificationActions';
import { getEducationLevel } from 'ReduxLoop/constants';
import * as ACTIONS from './schoolManagerActions';

const initialState = {
  currentOUKey: null,
  currentOrganisationalUnit: null,
  educationLevel: null,
  teamMetaInfo: null,
  teamMemberOus: {
    ous: {},
    relations: {},
    presidents: [],
    parentRelations: [],
  },
  // contactDetails: new Map(),
  // contactDetailsFetched: false,
  governingInstitution: {
    ou: null,
    mailAddress: null,
  },
  selectedTab: null,
  deprecatedOrganisationHref: null,
  isDetailsFormValid: true,
  nameErrors: [],
  shortNameErrors: [],
  descriptionErrors: [],
};

const saveDetails = (newState) => {
  if (
    !newState.isDetailsFormValid ||
    newState.descriptionErrors.length > 0 ||
    newState.nameErrors.length > 0 ||
    newState.shortNameErrors.length > 0
  ) {
    return newState;
  }
  return loop(
    newState,
    Cmd.run(storeResource, {
      args: [newState.currentOrganisationalUnit],
      successActionCreator: () =>
        ACTIONS.saveOrganisationDetailsSuccess(newState.currentOrganisationalUnit),
      failActionCreator: ACTIONS.saveOrganisationDetailsFailed,
    })
  );
};

export const schoolManagerReducer = (state = initialState, action, rootState) => {
  switch (action.type) {
    case ACTIONS.INITIALISE_SCHOOLMANAGER: {
      const newState = { ...state, currentOUKey: action.payload };
      const commandList = [];
      if (!rootState.userState.user) {
        commandList.push(Cmd.action(fetchUser()));
      }
      commandList.push(Cmd.action(ACTIONS.selectOrganisationalUnit(action.payload)));
      return loop(newState, Cmd.list(commandList, { sequence: true }));
    }

    case ACTIONS.SELECT_ORGANISATIONAL_UNIT: {
      const newState = {
        ...initialState,
        currentOUKey: action.payload,
        deprecatedOrganisationHref: null,
        selectedTab: state.selectedTab,
      };
      const ou = rootState.userState.ous ?
        rootState.userState.ous[`/sam/organisationalunits/${action.payload}`] || rootState.userState.ous[`/kathondvla/organisationalunits/${action.payload}`]
        : null;
      if (ou) {
        // newState.contactDetails = rootState.userState.contactDetails;
        // newState.contactDetailsFetched = true;
        return loop(newState, Cmd.action(ACTIONS.currentOuFetched(ou)));
      }
      return loop(
        newState,
        Cmd.run(getOrganisationalUnit, {
          args: [action.payload],
          successActionCreator: ACTIONS.currentOuFetched,
        })
      );
    }

    case ACTIONS.CURRENT_OU_FETCHED: {
      const commandList = [];
      const ou = action.payload;
      const newState = { ...state, currentOrganisationalUnit: ou };
      if (ou.type === 'SCHOOLENTITY' || ou.type === 'SCHOOL') {
        commandList.push(Cmd.run(getMainstructuresForOu, { args: [ou], successActionCreator: ACTIONS.currentOuEducationLevelFetched }));
      } else {
        commandList.push(Cmd.action(ACTIONS.currentOuEducationLevelFetched([])));
        /* commandList.push(Cmd.run(getVosEquivalent, {
          args: [ou, []],
          successActionCreator: ACTIONS.vosEquivalentFetched
        }));
        if (!state.selectedTab) {
          const defaultTab = getDefaultTab(
            action.payload.type,
            getCurrentUserRole(action.payload, rootState.vm.user)
          );
          commandList.push(Cmd.action(ACTIONS.selectTab(defaultTab.state)));
        } */
      }
      if (isBefore(ou.endDate, getNow())) {
        commandList.push(Cmd.action(addErrorNotification(
          `Deze ${ou.$$meta.permalink.split('/')[1] === 'sam' ? 'instelling' : 'organisatie'} is afgeschaft sinds ${printDate(ou.endDate)}`
        )));
      }
      /* if (!state.selectedTab) {
        const defaultTab = getDefaultTab(
          action.payload.type,
          getCurrentUserRole(action.payload, rootState.vm.user)
        );
        commandList.push(Cmd.action(ACTIONS.selectTab(defaultTab.state)));
      } */
      if (ou.type === 'SCHOOLENTITY') {
        commandList.push(
          Cmd.run(getGoverningInstitutionOfOu, {
            args: [ou],
            successActionCreator: ACTIONS.currentOuGoverningInstitutionFetched,
          })
        );
      }
      /* if (!state.contactDetailsFetched && ou.$$meta.type !== 'ORGANISATION') {
        commandList.push(Cmd.run(getContactDetails, {
          args: [ou],
          successActionCreator: ACTIONS.currentOuContactDetailsFetched
        }));
      } */
      // Fetch permalink that should be filled in for deprecated organisation.href property on responsibilities
      /* commandList.push(Cmd.run(getVosEquivalent, {
        args: [ou],
        successActionCreator: ACTIONS.vosEquivalentFetched
      })); */
      return loop(newState, Cmd.list(commandList));
    }

    case ACTIONS.CURRENT_OU_EDUCATION_LEVEL_FETCHED: {
      const commandList = [];
      const mainstructures = action.payload.mainstructures;
      const educationLevel = getEducationLevel(mainstructures.map((ms) => ms.code)) || 'NONE';
      commandList.push(Cmd.run(getVosEquivalent, {
        args: [state.currentOrganisationalUnit, educationLevel],
        successActionCreator: ACTIONS.vosEquivalentFetched
      }));
      return loop(
        { ...state, educationLevel, mainstructures: new Set(mainstructures.map((ms) => ms.$$meta.permalink)) },
        Cmd.list(commandList)
      );
    }

    case ACTIONS.VOS_EQUIVALENT_FETCHED: {
      return { ...state, deprecatedOrganisationHref: action.payload };
    }

    /* case ACTIONS.CURRENT_OU_CONTACTDETAILS_FETCHED: {
      return Object.assign({}, state, { contactDetails: Map(arrayToMap(action.payload)) });
    } */

    case ACTIONS.CURRENT_OU_GOVERNING_INSTITUTION_FETCHED: {
      return {
        ...state,
        governingInstitution: {
          ou: action.payload.governingInstitution,
          mailAddress: action.payload.mailContactDetail,
        },
      };
    }

    case ACTIONS.SELECT_TAB:
      return { ...state, selectedTab: action.payload };

    case ACTIONS.SET_DETAILS_FORM_VALIDATION: {
      return { ...state, isDetailsFormValid: action.payload };
    }

    case ACTIONS.CHANGE_DETAILS_NAME: {
      const shortNames = state.currentOrganisationalUnit.names.filter((name) => name.type === 'SHORT');
      const names = state.currentOrganisationalUnit.names.filter((name) => name.type === 'OFFICIAL');
      const currentName = getActiveResources(names)[0];
      if (action.payload === currentName.value) {
        return state;
      }
      let newNames = null;
      // case 1: the current name is already 3 months old so the previous name should be stored historically
      if (isBefore(currentName.startDate, getPreviousMonth(getNow(), 3))) {
        newNames = [
          ...names.filter((name) => name.startDate !== currentName.startDate),
          { ...currentName, endDate: getNow() },
          { type: 'OFFICIAL', value: action.payload, startDate: getNow() },
        ];
      } else {
        const previousName = names.find((name) => name.endDate === currentName.startDate);
        if (previousName && previousName.value === action.payload) {
          // case 2: the current name is younger than 3 months old and the name is changed back to what it was previously
          newNames = [
            ...names.filter((name) => name.startDate !== currentName.startDate && name.startDate !== previousName.startDate),
            { ...previousName, endDate: undefined },
          ];
        } else {
          // case 3: the current name is younger than 3 months old and the name is just replaced
          newNames = [
            ...names.filter((name) => name.startDate !== currentName.startDate),
            { ...currentName, value: action.payload },
          ];
        }
      }
      const newState = {
        ...state,
        nameErrors: [],
        currentOrganisationalUnit: { ...state.currentOrganisationalUnit, names: [...newNames, ...shortNames] },
      };
      return saveDetails(newState);
    }

    case ACTIONS.CHANGE_DETAILS_SHORT_NAME: {
      const shortNames = state.currentOrganisationalUnit.names.filter((name) => name.type === 'SHORT');
      const names = state.currentOrganisationalUnit.names.filter((name) => name.type === 'OFFICIAL');
      const currentShortName = getActiveResources(shortNames)[0];
      if (action.payload === currentShortName.value) {
        return state;
      }
      let newShortNames = null;
      // case 1: the current shortName is already 3 months old so the previous name should be stored historically
      if (isBefore(currentShortName.startDate, getPreviousMonth(getNow(), 3))) {
        newShortNames = [
          ...shortNames.filter((name) => name.startDate !== currentShortName.startDate),
          { ...currentShortName, endDate: getNow() },
          { type: 'SHORT', value: action.payload, startDate: getNow() },
        ];
      } else {
        const previousShortName = shortNames.find((name) => name.endDate === currentShortName.startDate);
        if (previousShortName && previousShortName.value === action.payload) {
          // case 2: the current detail is younger than 3 months old and the shortName is changed back to what it was previously
          newShortNames = [
            ...shortNames.filter((name) => name.startDate !== currentShortName.startDate && name.startDate !== previousShortName.startDate),
            { ...previousShortName, endDate: undefined },
          ];
        } else {
          // case 3: the current detail is younger than 3 months old and the shortName is just replaced
          newShortNames = [
            ...shortNames.filter((name) => name.startDate !== currentShortName.startDate),
            { ...currentShortName, value: action.payload },
          ];
        }
      }
      const newState = {
        ...state,
        shortNameErrors: [],
        currentOrganisationalUnit: {
          ...state.currentOrganisationalUnit,
          names: [...names, ...newShortNames],
          $$displayName: action.payload,
        },
      };
      return saveDetails(newState);
    }

    case ACTIONS.CHANGE_DETAILS_DESCRIPTION: {
      const byteLength = new Blob([action.payload.trim()]).size;
      const newState = {
        ...state,
        currentOrganisationalUnit: {
          ...state.currentOrganisationalUnit,
          description: action.payload,
        },
      };
      if (!action.payload || action.payload.length === 0) {
        newState.descriptionErrors = [
          { code: 'description.required', message: 'De beschrijving is verplicht' },
        ];
      } else if (action.payload.trim().length < 140) {
        newState.descriptionErrors = [
          {
            message: `De beschrijving moet minimum 140 tekens lang zijn. Huidig aantal tekens: ${action.payload.length}`,
          },
        ];
      } else if (byteLength > 1024) {
        newState.descriptionErrors = [
          {
            message: `De beschrijving mag maximum 1024 bytes lang zijn. Huidige grootte: ${byteLength} bytes`,
          },
        ];
      } else {
        newState.descriptionErrors = [];
      }
      return saveDetails(newState);
    }

    case ACTIONS.CHANGE_DETAILS_TYPE: {
      const newState = {
        ...state,
        currentOrganisationalUnit: { ...state.currentOrganisationalUnit, type: action.payload },
      };
      return saveDetails(newState);
    }

    case ACTIONS.SAVE_ORGANISATION_DETAILS_SUCCESS: {
      return loop(
        state,
        Cmd.action(addSuccessNotification('De details van het team zijn succesvol opgeslagen'))
      );
    }

    case ACTIONS.SAVE_ORGANISATION_DETAILS_FAILED: {
      if (
        action.payload instanceof SriClientError &&
        action.payload.body &&
        action.payload.body.errors
      ) {
        const { errors } = action.payload.body;
        const newState = { ...state };
        if (errors.some((error) => error.code === 'identical.organisation.in.overlapping.period')) {
          newState.nameErrors = [{ message: 'Er is al een ander team met dezelfde naam' }];// TODO needs to be added in Sam Api
        }
        if (errors.some((error) => error.code === 'shortname.not.unique')) {
          newState.shortNameErrors = [
            { message: 'Er is al een ander team met dezelfde korte naam' },// TODO needs to be added in Sam Api
          ];
        }
        if (newState.nameErrors.length > 0 || newState.shortNameErrors.length > 0) {
          return newState;
        }
        console.log('errors', errors);
      }
      return loop(
        state,
        Cmd.action(
          addErrorNotification(
            'Er is een onverwachte fout opgetreden bij het opslaan van de details van het team'
          )
        )
      );
    }

    default:
      return state;
  }
};
